import { useEffect, useState } from "react";
import axios from "../../../axios";
import ProductForm from "../../components/Product/ProductForm";
import { useNavigate, useParams } from "react-router-dom";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
// import htmlToDraft from "html-to-draftjs";
import ErrorModal from "../../components/ErrorModal";
import handleApiError from "../../../utils/handleApiError";
import SuccessModal from "../../components/SuccessModal";
import { STORAGE_URL } from "../../../constants";

export default function ProductEditPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const [loading, setLoading] = useState(true);
    const [initialForm, setInitialForm] = useState(null);
    const [initialPhotos, setInitialPhotos] = useState([]);
    const [initialEditorState, setInitialEditorState] = useState(EditorState.createEmpty());
    const [initialRelations, setInitialRelations] = useState({
        sizes: [],
        cover_fabrics: [],
        cover_designs: [],
        page_numbers: [],
    });
    const [relationsOptions, setRelationsOptions] = useState({
        categories: [],
        subcategories: [],
        sizes: [],
        fabrics: [],
        designs: [],
        pages: [],
    });

    useEffect(() => {
        const fetchAll = async () => {
            try {
                const [productRes, catRes, sizeRes, fabRes, desRes] = await Promise.all([
                    axios.get(`/admin/products/${id}`),
                    axios.get("/admin/categories"),
                    axios.get("/admin/sizes"),
                    axios.get("/admin/cover-fabrics"),
                    axios.get("/admin/cover-designs"),
                    // axios.get("/admin/page-numbers"),
                ]);

                const product = productRes.data.product;
                const rsProduct = productRes.data;

                // Isi form awal
                setInitialForm({
                    name: product.name,
                    description: product.description,
                    category_id: product.category_id,
                    category_price: product.category_price,
                    subcategory_id: product.subcategory_id,
                    subcategory_price: product.subcategory_price,
                    weight: product.weight,
                    rating: product.rating,
                    status: product.status,
                });

                setInitialPhotos(
                    product.photos.map((p) => ({
                        preview: `${STORAGE_URL}${p.file_path}`,
                        file_path: p.file_path, // untuk keperluan tampil ulang
                    }))
                );

                // Editor isi dari HTML
                const blocksFromHTML = convertFromHTML(product.feature_and_design || "");
                const contentState = ContentState.createFromBlockArray(
                    blocksFromHTML.contentBlocks,
                    blocksFromHTML.entityMap
                );
                setInitialEditorState(EditorState.createWithContent(contentState));

                setInitialRelations({
                    sizes: product.sizes.map((s) => ({ id: s.id, name: s.name, price: s.pivot.additional_price })),
                    cover_fabrics: product.cover_fabrics.map((f) => ({ id: f.id, name: f.name, price: f.pivot.additional_price })),
                    cover_designs: product.cover_designs.map((d) => ({ id: d.id, name: d.name, price: d.pivot.additional_price })),
                    page_numbers: rsProduct.page_numbers.map((p) => ({ page_number_id: p.page_number_id, price: p.additional_price })),
                });

                const allSub = catRes.data.flatMap((cat) => cat.sub_categories || []);

                setRelationsOptions({
                    categories: catRes.data,
                    subcategories: allSub,
                    sizes: sizeRes.data,
                    fabrics: fabRes.data,
                    designs: desRes.data,
                    // pages: pageRes.data,
                    pages: rsProduct.page_numbers,
                });

                setLoading(false);
            } catch (err) {
                console.log(err)
                // alert("Gagal memuat produk");
                // navigate("/admin/products");
                setError(handleApiError(err));
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, [id, navigate]);

    const handleSubmit = async (formData) => {
        formData.append("_method", "PUT"); // Laravel mendukung PUT via POST
        try {
            await axios.post(`/admin/products/${id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            setSuccess("Data berhasil ditambahkan!");
        } catch (err) {
            setError(handleApiError(err));
        } finally {
            setLoading(false);
        }
    };

    if (loading || !initialForm) return <p>Loading...</p>;

    return (
        <div className="card mt-24">
            <ErrorModal error={error} onClose={() => setError("")} />
            <SuccessModal
                message={success}
                onClose={() => {
                    setSuccess("");
                    navigate("/admin/products");
                }}
            />

            <div className="card-header border-bottom">
                <h4 className="mb-4">Edit Produk</h4>
            </div>

            <div className="card-body">
                <ProductForm
                    onSubmit={handleSubmit}
                    initialForm={initialForm}
                    initialPhotos={initialPhotos}
                    initialEditorState={initialEditorState}
                    initialRelations={initialRelations}
                    relationsOptions={relationsOptions}
                />
            </div>
        </div>
    );
}
